import { yupResolver } from '@hookform/resolvers/yup'
import { Button, TextInput } from 'components/common'
import Modal from 'components/modal'
import { useState } from 'react'
import { useForm, UseFormReset } from 'react-hook-form'
import { newAreaSchema } from 'utils/schema/areasSchema'

interface Area {
  shortCode: string
  fullName: string
}

type CreateRmaModalProps = {
  isOpen: boolean
  closeModal: () => void
  onSuccess: (data: Area, reset: UseFormReset<Area>) => Promise<void>
}

const CreateAreaConfigModal = ({
  isOpen,
  closeModal,
  onSuccess,
}: CreateRmaModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<Area>({
    resolver: yupResolver(newAreaSchema),
  })

  const [loading, setLoading] = useState<boolean>(false)

  const handleAreaCreation = async (data: Area) => {
    setLoading(true)
    try {
      await onSuccess(data, reset)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      width={500}
      title={`Create Area Config`}
      titleClassname="text-xl font-semibold"
      isOpen={isOpen}
      closeModal={closeModal}
      customStyle={{
        padding: '25px 30px',
      }}
    >
      <form onSubmit={handleSubmit(handleAreaCreation)}>
        <TextInput
          register={register}
          name="shortCode"
          label="Short Code"
          error={errors?.shortCode?.message}
        />

        <TextInput
          register={register}
          name="fullName"
          label="Full Name"
          error={errors?.fullName?.message}
        />

        {/* Actions */}
        <div className="mt-10 flex w-full max-w-sm items-center gap-2">
          <Button
            disabled={loading}
            type="submit"
            className="w-full"
            buttonText="Confirm"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={closeModal}
          />
        </div>
      </form>
    </Modal>
  )
}

export default CreateAreaConfigModal
